import React, { useState } from "react";
import { ThemeToggler } from 'gatsby-plugin-dark-mode';
import { graphql, StaticQuery } from 'gatsby';
import { FaChevronDown, FaSun, FaMoon } from 'react-icons/fa';

export default () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    return (
        <StaticQuery
            query={graphql`
      query HeadingQuery {
        allAirtable(filter: {table: {eq: "data"}, data: {cover: {eq: true}, publish: {eq: true}}}, sort: {fields: data___published_date, order: DESC}) {
            nodes {
                recordId
                data {
                    story
                    slug
                }
            }
        }
      }
    `}
            render={data => (
                <nav className="modern-nav">
                    <div className="nav-inner">
                        <a className="nav-brand" href="/">
                            <img src="/oc-logo.png" alt="Oberlin College and Conservatory" />
                            <span className="nav-brand-divider"></span>
                            <span className="nav-title">Oberlin Photo Stories</span>
                        </a>

                        <button
                            className={`nav-hamburger ${menuOpen ? 'active' : ''}`}
                            onClick={() => setMenuOpen(!menuOpen)}
                            aria-label="Toggle navigation"
                            aria-expanded={menuOpen}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>

                        <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
                            <div className="nav-dropdown-wrapper">
                                <button
                                    className="nav-stories-btn"
                                    onClick={() => setDropdownOpen(!dropdownOpen)}
                                    aria-expanded={dropdownOpen}
                                >
                                    More Stories <FaChevronDown className={`nav-chevron ${dropdownOpen ? 'rotated' : ''}`} />
                                </button>
                                <div className={`nav-dropdown ${dropdownOpen ? 'open' : ''}`}>
                                    {data.allAirtable.nodes.map(node => (
                                        <a className="nav-dropdown-item" href={node.data.slug} key={node.recordId}>
                                            {node.data.story}
                                        </a>
                                    ))}
                                </div>
                            </div>

                            <ThemeToggler>
                                {({ theme, toggleTheme }) => (
                                    <button
                                        className="theme-toggle-btn"
                                        onClick={() => toggleTheme(theme === 'dark' ? 'light' : 'dark')}
                                        aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
                                    >
                                        <span className="theme-toggle-track">
                                            <FaSun className="theme-icon sun-icon" />
                                            <FaMoon className="theme-icon moon-icon" />
                                            <span className={`theme-toggle-thumb ${theme === 'dark' ? 'dark' : ''}`}></span>
                                        </span>
                                    </button>
                                )}
                            </ThemeToggler>
                        </div>
                    </div>
                </nav>
            )}
        />
    );
}